import React from "react";

import Router from "./routes";

import GlobalStyles from "./styles/global";

function App() {
  return (
    <>
      <Router />
      <GlobalStyles />
    </>
  );
}

export default App;
